/**
 * The room she performs in: three slow lights, dust rising through them, and a
 * vignette holding the eye in the middle.
 *
 * All of it is decoration and all of it is `aria-hidden` — a screen reader
 * hears the slide, not the weather. The motes are a fixed table rather than
 * random values so a re-render never teleports one across the screen, and so
 * the same slide looks the same twice.
 */

import type { CSSProperties } from 'react'

/** x %, drift, seconds, delay — spread out enough that no two rise together. */
const MOTES: ReadonlyArray<readonly [number, number, number, number]> = [
  [6, 3, 22, 0],
  [17, -2, 28, 6],
  [24, 5, 19, 12],
  [33, -4, 33, 3],
  [41, 2, 25, 17],
  [52, -5, 30, 9],
  [58, 4, 21, 21],
  [66, -3, 36, 1],
  [74, 6, 24, 14],
  [81, -2, 29, 8],
  [88, 3, 20, 19],
  [95, -6, 34, 4],
]

export function Aurora({ hue }: { hue: string }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="stage-aurora">
        <div className="stage-blob stage-blob-a" />
        <div className="stage-blob stage-blob-b" />
        <div className="stage-blob stage-blob-c" />
      </div>
      <div className="stage-tint" style={{ '--stage-hue': hue } as CSSProperties} />
      {MOTES.map(([left, drift, dur, delay]) => (
        <span
          key={left}
          className="stage-mote"
          style={
            {
              left: `${left}%`,
              '--drift': `${drift}vw`,
              '--dur': `${dur}s`,
              '--delay': `${delay}s`,
            } as CSSProperties
          }
        />
      ))}
      <div className="stage-vignette" />
    </div>
  )
}
